var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscardedCylinder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.57018C0.5 4.93862 4.10831 3.5 8.52374 3.5C12.9392 3.5 16.5 4.81577 16.5 6.44732V19.605C16.5 19.9208 15.7878 20.2015 14.8858 20.2015H2.11424C1.25964 20.2015 0.5 19.9383 0.5 19.605V6.44732V6.57018Z",
    stroke: "#3D3D3D",
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52203 3.44732V0.5M8.52203 0.5H5.86328M8.52203 0.5H11.1808",
    stroke: "#3D3D3D",
    strokeMiterlimit: 133.33,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.4649C3.49999 10.4164 3.50953 10.3684 3.5281 10.3235C3.54666 10.2787 3.57387 10.238 3.60818 10.2037L6.20369 7.608C6.27295 7.53882 6.36685 7.49997 6.46474 7.5H10.1353C10.2332 7.50002 10.3271 7.53894 10.3963 7.60818L12.992 10.2037C13.0612 10.273 13.1 10.3668 13.1 10.4647V14.1353C13.1 14.1838 13.0905 14.2318 13.0719 14.2766C13.0533 14.3215 13.0261 14.3622 12.9918 14.3965L10.3965 16.9918C10.3622 17.0261 10.3214 17.0534 10.2766 17.0719C10.2317 17.0905 10.1836 17.1 10.1351 17.1H6.46492C6.41641 17.1 6.36837 17.0905 6.32354 17.0719C6.27872 17.0533 6.23799 17.0261 6.20369 16.9918L3.60818 14.3965C3.57385 14.3622 3.54662 14.3214 3.52806 14.2766C3.5095 14.2317 3.49996 14.1836 3.5 14.1351V10.4649Z",
    stroke: "#3D3D3D",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 14.5L10.5 10.5M6.5 10.5L10.5 14.5",
    stroke: "#3D3D3D",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardedCylinder);
export default __webpack_public_path__ + "static/media/Discarded Cylinder.b07bee3bbed2e0dd638b6c2c4310e81f.svg";
export { ForwardRef as ReactComponent };